import { render, staticRenderFns } from "./UserActivationPage.vue?vue&type=template&id=e632b8ec&scoped=true"
import script from "./UserActivationPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserActivationPage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UserActivationPage.vue?vue&type=style&index=0&id=e632b8ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e632b8ec",
  null
  
)

export default component.exports